module.exports = __webpack_public_path__ + "img/EMC2.88e18a3b.svg";